import { compose } from 'redux';
import { connect } from 'react-redux';
import CountdownView from '../../../common/countdown/countdownView';
import { goToQuestion } from '../../../common/navigation/navigationActions';
import { IPS } from '../../../constants/measure';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';

const mapDispatchToProps = (dispatch) => ({
    onEndCounting: () => {
        dispatch(goToQuestion(IPS.ASSESSMENT, null, 1));
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.LOWER_LEFT,
});

const IPSCountdownContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(CountdownView);

export default IPSCountdownContainer;
